module.exports = __webpack_public_path__ + "img/6503.73e7591c.jpg";